// extracted by mini-css-extract-plugin
export var alignLeft = "J_rb d_fp d_bG d_dv";
export var alignCenter = "J_bP d_fq d_bD d_dw";
export var alignRight = "J_rc d_fr d_bH d_dx";
export var testimonialsContainer = "J_vD d_dW";
export var testimonialsContainerFull = "J_vF d_dT";
export var testimonialsMainHeader = "J_jw d_jw d_w d_cw";
export var testimonialsComponentParagraph = "J_jy d_jy";
export var testimonialsComponentSmall = "J_jx d_jx";
export var testimonialsComponentsWrapper = "J_js d_js d_y d_w d_cv d_b3 d_b5";
export var testimonialsComponentsWrapperDesign2 = "J_jt d_jt d_y d_w d_cv d_b3 d_b5 d_bC";
export var testimonialsComponentsWrapperDesign3 = "J_jv d_jv d_y d_w d_H d_b5 d_bT d_bz d_bJ d_bP d_bD";
export var testimonialsBackgroundColor = "J_vG d_d7";
export var colEqualHeight = "J_vH d_bz";
export var testimonialsColumnWrapper = "J_jz d_jz d_b3";
export var testimonialsImageWrapper = "J_jp d_jp d_w d_Z";
export var testimonialsImageWrapperDesign2 = "J_jq d_jq d_r d_Z d_bx";
export var testimonialsImageWrapperDesign3 = "J_jr d_jr d_Z d_bz";
export var design2TextWrapper = "J_vJ d_bC d_bP d_bJ";
export var design3 = "J_vK d_cD d_H";
export var imageDesign2 = "J_vL";
export var SmallSmall = "J_vM K_vM K_vQ K_wb";
export var SmallNormal = "J_vN K_vN K_vQ K_wc";
export var SmallLarge = "J_vP K_vP K_vQ K_v8";
export var exceptionWeight = "J_tr K_wg";